import { Control, FieldValues, FieldPath } from 'react-hook-form';
import AsyncSearchSelectRHF, {
  AsyncSearchSelectProps,
} from '@/components/asyncSelect/AsyncSearchSelectRHF.tsx';
import { withCancelledShown } from '@/components/asyncSelect/asyncSelectFilters.ts';
import { clientOption } from '@/components/asyncSelect/entitySelects/entityOptions.tsx';
import clientsApi from '@/features/dashboard/clients/api/clientsApi.ts';
import { clientsApiQueryKeys } from '@/features/dashboard/clients/api/clientsApi.queryKeys.ts';
import { ClientListDto } from '@/features/dashboard/clients/types/ClientListDto.ts';
import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';

type ClientSearchSelectProps<T extends FieldValues> = Omit<
  AsyncSearchSelectProps<T, ClientListDto>,
  'fetchFn' | 'toOption' | 'queryKey'
> & {
  fieldPathName: FieldPath<T>;
  control: Control<T>;
};

const fetchClients = (pageRequest: PageRequest, filter: FilterCriteriaDto) =>
  clientsApi.getClients(pageRequest, withCancelledShown(filter));

const ClientSearchSelectRHF = <T extends FieldValues>({
  ...props
}: ClientSearchSelectProps<T>) => {
  return (
    <AsyncSearchSelectRHF<T, ClientListDto>
      {...props}
      queryKey={clientsApiQueryKeys.all()}
      fetchFn={fetchClients}
      toOption={clientOption}
    />
  );
};

export default ClientSearchSelectRHF;
